@file:OptIn(ExperimentalMaterial3Api::class, ExperimentalFoundationApi::class, ExperimentalLayoutApi::class)

package com.example.monetix.ui.dialogs

import androidx.compose.ui.focus.onFocusChanged
import androidx.compose.animation.AnimatedVisibility
import androidx.compose.animation.animateContentSize
import androidx.compose.animation.core.animateDpAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.BorderStroke
import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.gestures.snapping.rememberSnapFlingBehavior
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.layout.ExperimentalLayoutApi
import androidx.compose.foundation.lazy.LazyColumn
import androidx.compose.foundation.lazy.LazyRow
import androidx.compose.foundation.lazy.grid.GridCells
import androidx.compose.foundation.lazy.grid.LazyVerticalGrid
import androidx.compose.foundation.lazy.grid.items
import androidx.compose.foundation.lazy.items
import androidx.compose.foundation.lazy.rememberLazyListState
import androidx.compose.foundation.rememberScrollState
import androidx.compose.foundation.shape.CircleShape
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.foundation.text.KeyboardOptions
import androidx.compose.foundation.verticalScroll
import androidx.compose.foundation.ExperimentalFoundationApi
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material.icons.filled.ArrowDownward
import androidx.compose.material.icons.filled.AddCircleOutline
import androidx.compose.material.icons.filled.CalendarMonth
import androidx.compose.material.icons.filled.Close
import androidx.compose.material.icons.filled.KeyboardArrowDown
import androidx.compose.material.icons.filled.KeyboardArrowUp
import androidx.compose.material.icons.filled.MoreVert
import androidx.compose.material.icons.filled.Search
import androidx.compose.material.icons.outlined.CameraAlt
import androidx.compose.material.icons.outlined.Delete
import androidx.compose.material.icons.outlined.Mic
import androidx.compose.material.icons.outlined.Search
import androidx.compose.material3.*
import com.example.monetix.ui.components.MonetixTextField as OutlinedTextField
import com.example.monetix.ui.components.TxLogo
import androidx.compose.runtime.*
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.layout.ContentScale
import androidx.compose.ui.draw.clip
import androidx.compose.ui.draw.blur
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.Brush
import androidx.compose.ui.platform.LocalUriHandler
import androidx.compose.ui.text.TextRange
import androidx.compose.ui.text.font.FontWeight
import androidx.compose.ui.text.input.KeyboardType
import androidx.compose.ui.text.input.TextFieldValue
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import androidx.compose.ui.zIndex
import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.foundation.interaction.collectIsFocusedAsState
import androidx.compose.runtime.saveable.rememberSaveable
import androidx.compose.ui.hapticfeedback.HapticFeedbackType
import androidx.compose.ui.platform.LocalHapticFeedback
import androidx.compose.ui.window.Dialog
import androidx.compose.ui.window.DialogProperties
import androidx.compose.ui.window.PopupProperties

import com.example.monetix.HomeViewModel
import com.example.monetix.TYPE_EXPENSE
import com.example.monetix.TYPE_INCOME
import com.example.monetix.TYPE_TRANSFER
import com.example.monetix.db.MonetixDatabase
import com.example.monetix.db.AccountEntity
import com.example.monetix.db.CategoryEntity
import com.example.monetix.db.FinancingEntity
import com.example.monetix.db.RecurringExpenseEntity
import com.example.monetix.db.SavingsGoalEntity
import com.example.monetix.db.TransactionEntity
import com.example.monetix.stripSystemMarker
import com.example.monetix.utils.rememberMediaHandler
import app.cash.sqldelight.async.coroutines.awaitAsList

import kotlinx.coroutines.launch
import kotlinx.datetime.Clock
import kotlinx.datetime.Instant
import kotlinx.datetime.LocalDate
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlinx.datetime.todayIn
import kotlin.random.Random
import kotlin.math.roundToInt
import coil3.compose.AsyncImage
import kotlinx.coroutines.Dispatchers
import com.example.monetix.ui.screens.WheelPicker

import com.example.monetix.utils.autoFaviconUrlForName
import com.example.monetix.utils.rememberReceiptScanner
import com.example.monetix.formatEuroFromCents
import androidx.compose.material3.AlertDialog
import androidx.compose.material3.TextButton
import com.example.monetix.ui.components.MonetixGlassSwitch
import com.russhwolf.settings.Settings

private data class EditPredefMerchant(
    val name: String,
    val suggestedCategory: String,
    val suggestedSubcategory: String,
    val domain: String? = null,
    val emoji: String? = null,
    val customUrl: String? = null
) {
    val url get() = customUrl ?: domain?.let { "https://icon.horse/icon/$it" }
}

private val editMerchantSuggestions = listOf(
    EditPredefMerchant("Amazon", "SHOPPING", "E-commerce", "amazon.it"),
    EditPredefMerchant("Lidl", "SPESA", "Supermercato", "lidl.it"),
    EditPredefMerchant("Esselunga", "SPESA", "Supermercato", "esselunga.it"),
    EditPredefMerchant("Conad", "SPESA", "Supermercato", "conad.it"),
    EditPredefMerchant("Coop", "SPESA", "Supermercato", "e-coop.it"),
    EditPredefMerchant("Eurospin", "SPESA", "Supermercato", "eurospin.it"),
    EditPredefMerchant("Carrefour", "SPESA", "Supermercato", "carrefour.it"),
    EditPredefMerchant("Netflix", "RISTORANTI E SVAGO", "Streaming", "netflix.com"),
    EditPredefMerchant("Spotify", "RISTORANTI E SVAGO", "Streaming", domain = "spotify.com"),
    EditPredefMerchant("McDonald's", "RISTORANTI E SVAGO", "Fast Food", "mcdonalds.it"),
    EditPredefMerchant("Deliveroo", "RISTORANTI E SVAGO", "Delivery", "deliveroo.it"),
    EditPredefMerchant("Just Eat", "RISTORANTI E SVAGO", "Delivery", "justeat.it"),
    EditPredefMerchant("Q8", "AUTO E TRASPORTI", "Carburante", emoji = "⛽"),
    EditPredefMerchant("Eni Station", "AUTO E TRASPORTI", "Carburante", emoji = "⛽"),
    EditPredefMerchant("IP", "AUTO E TRASPORTI", "Carburante", emoji = "⛽"),
    EditPredefMerchant("Telepass", "AUTO E TRASPORTI", "Pedaggi", emoji = "🛣️"),
    EditPredefMerchant("Trenitalia", "AUTO E TRASPORTI", "Biglietti Trasporto", "trenitalia.com"),
    EditPredefMerchant("Acqua & Sapone", "CASA E BOLLETTE", "Igiene", emoji = "🧼"),
    EditPredefMerchant("Tigotà", "CASA E BOLLETTE", "Igiene", emoji = "🧼"),
    EditPredefMerchant("IKEA", "CASA E BOLLETTE", "Arredamento", "ikea.com"),
    EditPredefMerchant("Farmacia", "SALUTE", "Farmaci", emoji = "💊"),
    EditPredefMerchant("Stipendio", "STIPENDIO E ENTRATE", "Stipendio Mensile", emoji = "💶"),
    EditPredefMerchant("Satispay", "SHOPPING", "Pagamenti Smart", "satispay.com")
)

private fun detectEditSmartMerchant(input: String): EditPredefMerchant? {
    val cleanInput = input.trim().lowercase()
    if (cleanInput.length < 3) return null
    return editMerchantSuggestions.firstOrNull { it.name.lowercase().contains(cleanInput) }
}

@Composable
private fun StableWebTextField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    modifier: Modifier = Modifier,
    trailingIcon: @Composable (() -> Unit)? = null,
    leadingIcon: @Composable (() -> Unit)? = null,
    enabled: Boolean = true,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() },
    keyboardType: KeyboardType = KeyboardType.Text
) {
    OutlinedTextField(
        value = value,
        onValueChange = onValueChange,
        label = { Text(label, style = MaterialTheme.typography.labelSmall) },
        maxLines = 1,
        enabled = enabled,
        modifier = modifier.fillMaxWidth().onFocusChanged { focusState -> 
            if (focusState.isFocused && value != "") {
                onValueChange("")
            }
        },
        shape = RoundedCornerShape(14.dp),
        trailingIcon = trailingIcon,
        leadingIcon = leadingIcon,
        interactionSource = interactionSource,
        keyboardOptions = KeyboardOptions(keyboardType = keyboardType, autoCorrectEnabled = false),
        colors = OutlinedTextFieldDefaults.colors(
            focusedTextColor = Color.White,
            unfocusedTextColor = Color.White,
            focusedContainerColor = Color.White.copy(alpha = 0.12f),
            unfocusedContainerColor = Color.White.copy(alpha = 0.08f),
            focusedBorderColor = Color.White.copy(alpha = 0.40f),
            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
            focusedLabelColor = Color.White,
            unfocusedLabelColor = Color(0xFFA0A0A0)
        )
    )
}

@Composable
private fun StableWebNumberField(
    value: String,
    onValueChange: (String) -> Unit,
    label: String,
    modifier: Modifier = Modifier,
    trailingIcon: @Composable (() -> Unit)? = null,
    leadingIcon: @Composable (() -> Unit)? = null,
    enabled: Boolean = true,
    interactionSource: MutableInteractionSource = remember { MutableInteractionSource() }
) {
    OutlinedTextField(
        value = value,
        onValueChange = { newVal ->
            if (newVal.all { c -> c.isDigit() || c == ',' || c == '.' || c == ' ' }) onValueChange(newVal)
        },
        label = { Text(label, style = MaterialTheme.typography.labelSmall) },
        maxLines = 1,
        enabled = enabled,
        modifier = modifier.fillMaxWidth().onFocusChanged { focusState -> 
            if (focusState.isFocused && value != "") {
                onValueChange("")
            }
        },
        shape = RoundedCornerShape(14.dp),
        trailingIcon = trailingIcon,
        leadingIcon = leadingIcon,
        interactionSource = interactionSource,
        colors = OutlinedTextFieldDefaults.colors(
            focusedTextColor = Color.White,
            unfocusedTextColor = Color.White,
            focusedContainerColor = Color.White.copy(alpha = 0.12f),
            unfocusedContainerColor = Color.White.copy(alpha = 0.08f),
            focusedBorderColor = Color.White.copy(alpha = 0.40f),
            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
            focusedLabelColor = Color.White,
            unfocusedLabelColor = Color(0xFFA0A0A0)
        )
    )
}

@OptIn(ExperimentalFoundationApi::class)
@Composable
private fun AmountWheelDialog(
    initialAmount: String,
    onDismiss: () -> Unit,
    onConfirm: (String) -> Unit
) {
    val cleanInitial = initialAmount.replace(",", ".").ifBlank { "0.00" }
    val parts = cleanInitial.split(".")
    val initEuro = parts.getOrNull(0)?.toIntOrNull() ?: 0
    val initCents = parts.getOrNull(1)?.padEnd(2, '0')?.take(2)?.toIntOrNull() ?: 0

    val euros = (0..9999).toList()
    val cents = (0..99).toList()

    val euroState = rememberLazyListState(initialFirstVisibleItemIndex = initEuro)
    val centState = rememberLazyListState(initialFirstVisibleItemIndex = initCents)

    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text("Seleziona Importo", style = MaterialTheme.typography.titleMedium) },
        text = {
            Row(modifier = Modifier.fillMaxWidth().height(180.dp), horizontalArrangement = Arrangement.Center, verticalAlignment = Alignment.CenterVertically) {
                LazyColumn(state = euroState, flingBehavior = rememberSnapFlingBehavior(euroState), modifier = Modifier.weight(1f).height(150.dp), horizontalAlignment = Alignment.CenterHorizontally, contentPadding = PaddingValues(vertical = 55.dp)) {
                    items(euros.size) { i ->
                        val isSelected by remember { derivedStateOf { euroState.firstVisibleItemIndex == i } }
                        Text("${euros[i]}", fontSize = if (isSelected) 28.sp else 18.sp, fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Normal, color = if (isSelected) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.onSurface.copy(alpha = 0.4f), modifier = Modifier.padding(vertical = 6.dp))
                    }
                }
                Text(",", fontSize = 32.sp, fontWeight = FontWeight.Bold, modifier = Modifier.padding(horizontal = 8.dp))
                LazyColumn(state = centState, flingBehavior = rememberSnapFlingBehavior(centState), modifier = Modifier.weight(1f).height(150.dp), horizontalAlignment = Alignment.CenterHorizontally, contentPadding = PaddingValues(vertical = 55.dp)) {
                    items(cents.size) { i ->
                        val isSelected by remember { derivedStateOf { centState.firstVisibleItemIndex == i } }
                        Text(cents[i].toString().padStart(2, '0'), fontSize = if (isSelected) 28.sp else 18.sp, fontWeight = if (isSelected) FontWeight.Bold else FontWeight.Normal, color = if (isSelected) MaterialTheme.colorScheme.primary else MaterialTheme.colorScheme.onSurface.copy(alpha = 0.4f), modifier = Modifier.padding(vertical = 6.dp))
                    }
                }
            }
        },
        confirmButton = { Button(onClick = { onConfirm("${euros[euroState.firstVisibleItemIndex]},${cents[centState.firstVisibleItemIndex].toString().padStart(2, '0')}") }) { Text("CONFERMA") } },
        dismissButton = { TextButton(onClick = onDismiss) { Text("ANNULLA") } }
    )
}

@OptIn(ExperimentalMaterial3Api::class)
@Composable
private fun WebImagePickerPopup(
    initialQuery: String,
    onDismiss: () -> Unit,
    onImageSelected: (String) -> Unit
) {
    var query by remember { mutableStateOf(initialQuery) }
    var results by remember { mutableStateOf<List<String>>(emptyList()) }
    val uriHandler = LocalUriHandler.current

    val popularBrands = remember {
        listOf("Amazon", "Netflix", "Spotify", "PayPal", "Iliad", "Postepay", "Enel", "Trenitalia", "Conad", "Coop", "McDonald's", "Apple", "Uber", "Deliveroo")
    }

    fun generateLinks(qRaw: String) {
        val q = qRaw.trim().lowercase().replace(" ", "")
        if (q.isEmpty()) {
            results = emptyList()
            return
        }
        val domain = if (q.contains(".")) q else "$q.com"
        val domainIt = if (q.contains(".")) q else "$q.it"

        results = listOf(
            "https://unavatar.io/$domain",
            "https://unavatar.io/$domainIt",
            "https://icon.horse/icon/$domain",
            "https://icon.horse/icon/$domainIt",
            "https://www.google.com/s2/favicons?domain=$domain&sz=128",
            "https://www.google.com/s2/favicons?domain=$domainIt&sz=128"
        ).distinct()
    }

    LaunchedEffect(initialQuery) {
        if (initialQuery.isNotBlank()) generateLinks(initialQuery)
    }

    AlertDialog(
        onDismissRequest = onDismiss,
        shape = RoundedCornerShape(28.dp),
        containerColor = Color(0xFF1E1B4B),
        title = {
            Row(verticalAlignment = Alignment.CenterVertically) {
                Surface(
                    shape = CircleShape,
                    color = Color(0xFF60A5FA).copy(alpha = 0.2f),
                    modifier = Modifier.size(36.dp)
                ) {
                    Icon(
                        imageVector = Icons.Default.Search,
                        contentDescription = null,
                        tint = Color(0xFF60A5FA),
                        modifier = Modifier.padding(8.dp)
                    )
                }
                Spacer(Modifier.width(12.dp))
                Column {
                    Text(
                        "Ricerca Logo Web 🌐",
                        style = MaterialTheme.typography.titleMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White
                    )
                    Text(
                        "Trova il logo ufficiale del merchant",
                        style = MaterialTheme.typography.labelSmall,
                        color = Color.White.copy(alpha = 0.6f)
                    )
                }
            }
        },
        text = {
            Column(
                modifier = Modifier.fillMaxWidth().verticalScroll(rememberScrollState()),
                verticalArrangement = Arrangement.spacedBy(14.dp)
            ) {
                OutlinedTextField(
                    value = query,
                    onValueChange = {
                        query = it
                        generateLinks(it)
                    },
                    label = { Text("Brand o Nome Azienda", color = Color(0xFFA0A0A0)) },
                    placeholder = { Text("es. Netflix, Amazon, Iliad...", color = Color(0xFFA0A0A0)) },
                    trailingIcon = {
                        if (query.isNotBlank()) {
                            IconButton(onClick = { query = ""; results = emptyList() }) {
                                Icon(Icons.Default.Close, contentDescription = "Cancella", tint = Color.White.copy(alpha = 0.6f))
                            }
                        } else {
                            Icon(Icons.Default.Search, contentDescription = null, tint = Color(0xFF60A5FA))
                        }
                    },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(14.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedTextColor = Color.White,
                        unfocusedTextColor = Color.White,
                        focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                        unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                        focusedBorderColor = Color(0xFF60A5FA),
                        unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                    )
                )

                Text("Brand frequenti:", style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.7f))
                LazyRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                    items(popularBrands) { brand ->
                        FilterChip(
                            selected = query.equals(brand, ignoreCase = true),
                            onClick = { query = brand; generateLinks(brand) },
                            label = { Text(brand, fontSize = 11.sp, fontWeight = FontWeight.SemiBold) },
                            colors = FilterChipDefaults.filterChipColors(
                                selectedContainerColor = Color(0xFF60A5FA),
                                selectedLabelColor = Color.White,
                                containerColor = Color.White.copy(alpha = 0.08f),
                                labelColor = Color.White.copy(alpha = 0.8f)
                            ),
                            border = null
                        )
                    }
                }

                if (results.isNotEmpty()) {
                    Text("Tocca il logo da usare:", style = MaterialTheme.typography.labelSmall, color = Color.White.copy(alpha = 0.7f))
                    LazyVerticalGrid(
                        columns = GridCells.Adaptive(64.dp),
                        horizontalArrangement = Arrangement.spacedBy(10.dp),
                        verticalArrangement = Arrangement.spacedBy(10.dp),
                        modifier = Modifier.height(160.dp).fillMaxWidth()
                    ) {
                        items(results) { url ->
                            Surface(
                                modifier = Modifier
                                    .aspectRatio(1f)
                                    .clickable { onImageSelected(url) },
                                shape = RoundedCornerShape(16.dp),
                                color = Color.White.copy(alpha = 0.15f),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                            ) {
                                AsyncImage(
                                    model = url,
                                    contentDescription = null,
                                    modifier = Modifier.fillMaxSize().padding(10.dp),
                                    contentScale = ContentScale.Fit
                                )
                            }
                        }
                    }
                } else {
                    Box(modifier = Modifier.height(80.dp).fillMaxWidth(), contentAlignment = Alignment.Center) {
                        Text("Digita il nome di un brand per caricare i loghi", style = MaterialTheme.typography.bodySmall, color = Color(0xFFA0A0A0))
                    }
                }

                HorizontalDivider(color = Color.White.copy(alpha = 0.10f))

                Button(
                    onClick = {
                        val q = if (query.isNotBlank()) "${query} logo icon" else "logo icon"
                        uriHandler.openUri("https://www.google.com/search?tbm=isch&q=${q.replace(" ", "+")}")
                    },
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(12.dp),
                    colors = ButtonDefaults.buttonColors(containerColor = Color.White.copy(alpha = 0.12f), contentColor = Color.White)
                ) {
                    Icon(Icons.Outlined.Search, contentDescription = null, modifier = Modifier.size(18.dp), tint = Color(0xFF60A5FA))
                    Spacer(Modifier.width(8.dp))
                    Text("Cerca immagini su Google ↗", style = MaterialTheme.typography.labelMedium)
                }

                var manualUrl by remember { mutableStateOf("") }
                OutlinedTextField(
                    value = manualUrl,
                    onValueChange = { manualUrl = it },
                    label = { Text("O incolla URL immagine", color = Color(0xFFA0A0A0)) },
                    placeholder = { Text("https://...", color = Color(0xFFA0A0A0)) },
                    singleLine = true,
                    modifier = Modifier.fillMaxWidth(),
                    shape = RoundedCornerShape(14.dp),
                    colors = OutlinedTextFieldDefaults.colors(
                        focusedTextColor = Color.White,
                        unfocusedTextColor = Color.White,
                        focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                        unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                        focusedBorderColor = Color(0xFF60A5FA),
                        unfocusedBorderColor = Color.White.copy(alpha = 0.20f)
                    )
                )

                AnimatedVisibility(visible = manualUrl.isNotBlank()) {
                    Column(
                        modifier = Modifier.fillMaxWidth().padding(top = 4.dp),
                        horizontalAlignment = Alignment.CenterHorizontally
                    ) {
                        Surface(
                            modifier = Modifier.size(64.dp),
                            shape = RoundedCornerShape(16.dp),
                            color = Color.White.copy(alpha = 0.15f),
                            border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                        ) {
                            AsyncImage(
                                model = manualUrl.trim(),
                                contentDescription = "Anteprima URL",
                                modifier = Modifier.fillMaxSize().padding(8.dp),
                                contentScale = ContentScale.Fit
                            )
                        }
                        Spacer(Modifier.height(10.dp))
                        Button(
                            onClick = { onImageSelected(manualUrl.trim()) },
                            shape = RoundedCornerShape(12.dp),
                            colors = ButtonDefaults.buttonColors(containerColor = Color(0xFF60A5FA), contentColor = Color.White)
                        ) {
                            Text("Usa questa immagine", fontWeight = FontWeight.Bold)
                        }
                    }
                }
            }
        },
        confirmButton = {},
        dismissButton = {
            TextButton(onClick = onDismiss) {
                Text("ANNULLA", color = Color.White.copy(alpha = 0.6f), fontWeight = FontWeight.Bold)
            }
        }
    )
}

enum class EditTxAmountTarget { NONE, AMOUNT, FEE }

// ==========================================
// 🚀 DIALOG PRINCIPALE
// ==========================================

@OptIn(ExperimentalMaterial3Api::class, ExperimentalLayoutApi::class)
@Composable
fun EditTransactionDialog(
    viewModel: HomeViewModel,
    db: MonetixDatabase,
    original: TransactionEntity,
    saldoDisponibile: Long,
    categories: List<CategoryEntity>,
    accounts: List<AccountEntity>,
    onDismiss: () -> Unit,
    onSaved: () -> Unit,
    financings: List<FinancingEntity>,
    recurringItems: List<RecurringExpenseEntity>,
    savingsGoals: List<SavingsGoalEntity>
) {
    val scope = rememberCoroutineScope()
    val brandPrimary = MaterialTheme.colorScheme.primary
    val nowMs = Clock.System.now().toEpochMilliseconds()
    val today = Clock.System.todayIn(TimeZone.currentSystemDefault())

    // 🚀 STATI PER CONTROLLO SALDO E FONDO EMERGENZA
    var showSaldoWarning by remember { mutableStateOf(false) }
    var showSmartEmergencyWarning by remember { mutableStateOf(false) }
    var pendingEmergencyDeficit by remember { mutableStateOf(0L) }
    val settings = remember { Settings() }
    val emergencyTargetCents = remember { settings.getLong("emergency_fund_target", 500000L) }

    var latest by remember { mutableStateOf<List<TransactionEntity>>(emptyList()) }
    LaunchedEffect(Unit) {
        try { latest = db.transactionQueries.getAllTransactions().awaitAsList() } catch(e:Exception){}
    }

    // 🚀 CALCOLO SALDO DEL FONDO EMERGENZA
    val emergencyBalanceCents = remember(latest, today) {
        val todayEpochDays = today.toEpochDays().toLong()
        var sum = 0L
        for (tx in latest) {
            if (tx.isDeleted || tx.dateEpochDay > todayEpochDays) continue
            val isTarget = tx.accountId == "sys_emergency_fund" || tx.toAccountId == "sys_emergency_fund" || tx.fromAccountId == "sys_emergency_fund"
            if (!isTarget) continue
            when (tx.type) {
                "INCOME" -> if (tx.accountId == "sys_emergency_fund") sum += tx.amountCents
                "EXPENSE" -> if (tx.accountId == "sys_emergency_fund") sum -= tx.amountCents
                "TRANSFER" -> {
                    if (tx.fromAccountId == "sys_emergency_fund") sum -= tx.amountCents
                    if (tx.toAccountId == "sys_emergency_fund") sum += tx.amountCents
                }
            }
        }
        sum
    }

    val receiptScanner = rememberReceiptScanner()
    var isScanningReceipt by remember { mutableStateOf(false) }
    var isImageActionForOCR by rememberSaveable { mutableStateOf(false) }
    var receiptError by remember { mutableStateOf(false) }

    val safeDescOrig = original.description ?: ""
    val isFinancingInstallment = safeDescOrig.startsWith("[fin:")
    val isTransfer = original.type == TYPE_TRANSFER
    val isIncome = original.type == TYPE_INCOME

    val initialAmtStr = run {
        val euros = original.amountCents / 100
        val cents = kotlin.math.abs(original.amountCents % 100).toString().padStart(2, '0')
        "$euros,$cents"
    }

    var amountText by remember(original.id) { mutableStateOf(initialAmtStr) }
    val amountInteractionSource = remember { MutableInteractionSource() }
    val isAmountFocused by amountInteractionSource.collectIsFocusedAsState()
    LaunchedEffect(isAmountFocused) { if (isAmountFocused) amountText = "" }

    var feeText by remember { mutableStateOf("") }
    val feeInteractionSource = remember { MutableInteractionSource() }
    val isFeeFocused by feeInteractionSource.collectIsFocusedAsState()

    var isSavingsActive by remember { mutableStateOf(false) }
    var percentageText by remember { mutableStateOf("10") }
    val savingsInteractionSource = remember { MutableInteractionSource() }
    val isSavingsFocused by savingsInteractionSource.collectIsFocusedAsState()

    LaunchedEffect(isSavingsFocused) {
        if (isSavingsFocused) percentageText = ""
    }
    LaunchedEffect(isFeeFocused) { if (isFeeFocused) feeText = "" }

    val initialDateStr = try {
        val date = LocalDate.fromEpochDays(original.dateEpochDay.toInt())
        val day = date.dayOfMonth.toString().padStart(2, '0')
        val month = date.monthNumber.toString().padStart(2, '0')
        val year = date.year.toString()
        "$day/$month/$year"
    } catch (_: Throwable) { "${today.dayOfMonth.toString().padStart(2, '0')}/${today.monthNumber.toString().padStart(2, '0')}/${today.year}" }

    var dateTFV by remember(original.id) { mutableStateOf(TextFieldValue(initialDateStr, TextRange(initialDateStr.length))) }
    val dateInteractionSource = remember { MutableInteractionSource() }
    val isDateFocused by dateInteractionSource.collectIsFocusedAsState()
    LaunchedEffect(isDateFocused) { if (isDateFocused) dateTFV = TextFieldValue("", TextRange.Zero) }

    val onDateTFVChange: (TextFieldValue) -> Unit = { newVal ->
        val oldText = dateTFV.text
        val newText = newVal.text
        if (newText.length < oldText.length) {
            dateTFV = newVal
        } else {
            val clean = newText.replace("/", "").filter { it.isDigit() }
            val formatted = buildString {
                for (i in clean.indices) {
                    append(clean[i])
                    if ((i == 1 || i == 3) && i < 7) append("/")
                }
            }.take(10)
            dateTFV = TextFieldValue(formatted, TextRange(formatted.length))
        }
    }

    val markerRegex = remember { Regex("\\[(?:rec|fin|finfee|sav|cash|pb|goal):[^\\]]+\\]") }
    val hiddenMarker = remember(original.id) {
        markerRegex.find(safeDescOrig)?.value ?: markerRegex.find(original.merchantKey ?: "")?.value ?: ""
    }

    var merchant by remember(original.id) {
        mutableStateOf(
            stripSystemMarker(original.merchantKey ?: "")
                ?.replace(" \uD83D\uDC7B (Promemoria)", "")
                ?.trim() ?: ""
        )
    }

    var desc by remember(original.id) {
        mutableStateOf(
            stripSystemMarker(original.description ?: "")
                ?.replace(" \uD83D\uDC7B (Promemoria)", "")
                ?.trim() ?: ""
        )
    }

    var logoEmoji by remember(original.id) { mutableStateOf(original.logoEmoji ?: "") }
    var logoUri by remember(original.id) { mutableStateOf(original.logoUri ?: "") }
    var manualLogoSet by remember(original.id) { mutableStateOf(original.logoUri?.isNotBlank() == true || original.logoEmoji?.isNotBlank() == true) }

    var selectedAccountId by remember(original.id) {
        mutableStateOf((original.accountId ?: "").removePrefix("sys_ghost_").replace("tracker_account", ""))
    }
    var selectedFromAccountId by remember(original.id) {
        mutableStateOf((original.fromAccountId ?: "").removePrefix("sys_ghost_").replace("tracker_account", ""))
    }
    var selectedToAccountId by remember(original.id) {
        mutableStateOf((original.toAccountId ?: "").removePrefix("sys_ghost_").replace("tracker_account", ""))
    }
    var subcategory by remember(original.id) { mutableStateOf(original.subcategoryText ?: "") }

    val initialCategoryName = categories.firstOrNull { it.id == original.categoryId }?.name ?: ""
    var categoryText by remember(original.categoryId) { mutableStateOf(initialCategoryName) }
    var selectedCategoryId by remember(original.id) { mutableStateOf(original.categoryId ?: "") }

    var categoryMenuOpen by remember { mutableStateOf(false) }
    val catInteractionSource = remember { MutableInteractionSource() }
    val isCatFocused by catInteractionSource.collectIsFocusedAsState()

    var merchantSuggestionsExpanded by remember { mutableStateOf(false) }
    val merchantInteractionSource = remember { MutableInteractionSource() }
    val isMerchantFocused by merchantInteractionSource.collectIsFocusedAsState()

    var showDatePicker by remember { mutableStateOf(false) }
    var activeAmountTarget by remember { mutableStateOf(EditTxAmountTarget.NONE) }
    val datePickerState = rememberDatePickerState()

    var localCategories by remember { mutableStateOf<List<CategoryEntity>>(categories) }
    var pendingDeleteCat by remember { mutableStateOf<CategoryEntity?>(null) }
    var showEmojiInput by remember { mutableStateOf(false) }
    var showWebSearch by remember { mutableStateOf(false) }

    val isInnerPopupOpen = showWebSearch || showDatePicker || activeAmountTarget != EditTxAmountTarget.NONE || showSaldoWarning || showSmartEmergencyWarning
    val dialogBlur by animateDpAsState(
        targetValue = if (isInnerPopupOpen) 16.dp else 0.dp,
        animationSpec = tween(durationMillis = 300),
        label = "dialogBlur"
    )

    LaunchedEffect(isCatFocused) {
        if (isCatFocused) {
            if (categoryText == initialCategoryName || categoryText == "NESSUNA CATEGORIA") categoryText = ""
            categoryMenuOpen = true
        }
    }

    LaunchedEffect(categories) { localCategories = categories }

    val dynamicMerchantSuggestions = remember(latest, categories) {
        val userMerchants = latest
            .filter { !it.isDeleted && !it.merchantKey.isNullOrBlank() }
            .sortedByDescending { it.createdAtEpochMs }
            .mapNotNull { tx ->
                val cleanName = stripSystemMarker(tx.merchantKey)?.trim()
                if (cleanName.isNullOrBlank()) return@mapNotNull null

                val catName = categories.firstOrNull { it.id == tx.categoryId }?.name ?: ""
                val fallback = detectEditSmartMerchant(cleanName)
                val finalEmoji = tx.logoEmoji?.takeIf { it.isNotBlank() } ?: fallback?.emoji
                val finalUri = tx.logoUri?.takeIf { it.isNotBlank() }
                    ?: fallback?.customUrl
                    ?: fallback?.domain?.let { "https://icon.horse/icon/$it" }
                    ?: if (finalEmoji.isNullOrBlank()) autoFaviconUrlForName(cleanName) else null

                EditPredefMerchant(
                    name = cleanName,
                    suggestedCategory = catName,
                    suggestedSubcategory = tx.subcategoryText ?: "",
                    domain = null,
                    emoji = finalEmoji,
                    customUrl = finalUri
                )
            }

        (userMerchants + editMerchantSuggestions)
            .filter { stripSystemMarker(it.name)?.isNotBlank() == true }
            .distinctBy { it.name.uppercase().trim() }
    }

    LaunchedEffect(merchant) {
        if (!manualLogoSet) {
            val exactMerchant = merchant.trim().lowercase()
            if (exactMerchant.length >= 2) {
                val match = dynamicMerchantSuggestions.firstOrNull { it.name.lowercase() == exactMerchant }
                if (match != null) {
                    logoUri = match.url ?: ""
                    logoEmoji = match.emoji ?: ""
                    if (categoryText.isBlank()) categoryText = match.suggestedCategory
                    if (subcategory.isBlank()) subcategory = match.suggestedSubcategory
                } else {
                    logoUri = ""
                    logoEmoji = ""
                }
            } else {
                logoUri = ""
                logoEmoji = ""
            }
        }
    }

    val mediaHandler = rememberMediaHandler(
        onImageResult = { uri ->
            if (uri != null) {
                if (isImageActionForOCR) {
                    isImageActionForOCR = false
                    scope.launch {
                        isScanningReceipt = true
                        receiptError = false
                        try {
                            val data = receiptScanner.scanImage(uri.toString())
                            var foundData = false

                            if (data.total != null) {
                                amountText = data.total
                                foundData = true
                            }
                            if (data.merchant != null && merchant.isBlank()) {
                                merchant = data.merchant
                                merchantSuggestionsExpanded = true
                                foundData = true
                            }
                            if (data.date != null) {
                                dateTFV = TextFieldValue(data.date, TextRange(data.date.length))
                                foundData = true
                            }

                            if (!foundData) {
                                receiptError = true
                                desc = "ERRORE LETTURA:\n${data.rawText ?: "Nessun testo rilevato."}"
                            }
                        } catch(e: Exception) {
                            receiptError = true
                            desc = "ERRORE CRITICO: ${e.message}"
                        } finally {
                            isScanningReceipt = false
                        }
                    }
                } else {
                    logoUri = uri.toString()
                    logoEmoji = ""
                    manualLogoSet = true
                }
            } else {
                isImageActionForOCR = false
            }
        },
        onVoiceResult = { text -> if (!text.isNullOrBlank()) desc = text }
    )

    var isRealTransaction by remember(original.id) {
        mutableStateOf(
            !(original.accountId?.startsWith("sys_ghost_") == true ||
                    original.fromAccountId?.startsWith("sys_ghost_") == true ||
                    original.toAccountId?.startsWith("sys_ghost_") == true ||
                    original.accountId == "sys_ghost_tracker_account")
        )
    }

    val canSave = remember(amountText, selectedAccountId, selectedFromAccountId, selectedToAccountId, isRealTransaction) {
        val amtOk = parseEuroToCentsSafe(amountText) > 0L
        if (!isRealTransaction) return@remember amtOk
        if (isTransfer) amtOk && selectedFromAccountId.isNotBlank() && selectedToAccountId.isNotBlank() && selectedFromAccountId != selectedToAccountId
        else amtOk && selectedAccountId.isNotBlank()
    }

    // 🚀 LA NUOVA FUNZIONE DI SALVATAGGIO UNIVERSALE (Con Pulizia Automatica dei figli)
    val performSaveTransaction: (Boolean, Long) -> Unit = { useEmergency, deficitToCover ->
        scope.launch {
            val timeNowMs = Clock.System.now().toEpochMilliseconds()
            val finalAmount = parseEuroToCentsSafe(amountText)
            val finalDate = parseDayMonthYearSafe(dateTFV.text) ?: original.dateEpochDay
            val rawDesc = normalizeTextSafe(desc)
            val finalDesc = if (isFinancingInstallment) safeDescOrig else if (hiddenMarker.isNotEmpty()) { if (rawDesc.isEmpty()) hiddenMarker else "$rawDesc $hiddenMarker" } else rawDesc

            val mainTxId = original.id // 🚀 USIAMO L'ID ORIGINALE
            val isVaporizedTransaction = original.categoryId == "sys_vaporized" // 🚀 FIX: Leggiamo lo stato vaporizzato originale

            var finalCategoryId: String? = null
            val catTextClean = categoryText.trim().uppercase() // 🚀 FIX: Qui si chiama categoryText
            if (catTextClean.isNotEmpty() && catTextClean != "NESSUNA CATEGORIA") {
                val existing = categories.firstOrNull { !it.isDeleted && it.name.equals(catTextClean, ignoreCase = true) }
                if (existing != null) { finalCategoryId = existing.id }
                else {
                    val norm = catTextClean.lowercase().replace("\\s+".toRegex(), "_").replace("[^a-z0-9_]+".toRegex(), "")
                    val newId = "cat_$norm"
                    val newCat = CategoryEntity(newId, catTextClean, false, timeNowMs, timeNowMs)
                    try {
                        db.categoryQueries.upsert(newId, catTextClean, false, timeNowMs, timeNowMs)
                        viewModel.firestore.salva("categorie", newId, newCat)
                    } catch (_: Throwable) {}
                    finalCategoryId = newId
                }
            }

            var safeUri = logoUri.takeIf { it?.isNotBlank() == true }
            var safeEmoji = logoEmoji.takeIf { it.isNotBlank() }

            if (safeUri == null && safeEmoji == null) {
                val exactMerchant = merchant.trim().lowercase()
                val match = dynamicMerchantSuggestions.firstOrNull { it.name.lowercase() == exactMerchant }
                if (match != null) { safeUri = match.url; safeEmoji = match.emoji }
            }

            val finalAccountId = if (isRealTransaction) selectedAccountId else "sys_ghost_$selectedAccountId"
            val finalFromId = if (isRealTransaction) selectedFromAccountId else "sys_ghost_$selectedFromAccountId"
            val finalToId = if (isRealTransaction) selectedToAccountId else "sys_ghost_$selectedToAccountId"

            // 🚀 INTERVENTO SCUDO: AUTO-RICARICA E PULIZIA
            if (isIncome && isRealTransaction && !isVaporizedTransaction && finalAccountId.isNotBlank()) {
                val deficitTarget = emergencyTargetCents - emergencyBalanceCents
                if (deficitTarget > 0L) {
                    val refillAmount = minOf(finalAmount, deficitTarget)
                    val refillTx = TransactionEntity(
                        id = "tx_refill_$mainTxId", accountId = finalAccountId, toAccountId = "sys_emergency_fund", fromAccountId = finalAccountId, amountCents = refillAmount, type = "TRANSFER", dateEpochDay = finalDate, categoryId = "default",
                        description = "Ricarica automatica Scudo", merchantKey = "Fondo di Emergenza", subcategoryText = "Auto-Ricarica", logoEmoji = "🛡️", logoUri = null, isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = timeNowMs - 5, updatedAtEpochMs = timeNowMs - 5
                    )
                    viewModel.saveTransaction(refillTx)
                } else {
                    // Se non serve più la ricarica, LA ELIMINIAMO
                    val deadRefill = original.copy(id = "tx_refill_$mainTxId", isDeleted = true, updatedAtEpochMs = timeNowMs)
                    viewModel.saveTransaction(deadRefill)
                }
            } else {
                val deadRefill = original.copy(id = "tx_refill_$mainTxId", isDeleted = true, updatedAtEpochMs = timeNowMs)
                viewModel.saveTransaction(deadRefill)
            }

            // 🚀 INTERVENTO SCUDO: AUTO-PRELIEVO E PULIZIA
            if (useEmergency && deficitToCover > 0L && isRealTransaction && !isVaporizedTransaction && finalAccountId.isNotBlank()) {
                val drainTx = TransactionEntity(
                    id = "tx_drain_$mainTxId", accountId = finalAccountId, toAccountId = finalAccountId, fromAccountId = "sys_emergency_fund", amountCents = deficitToCover, type = "TRANSFER", dateEpochDay = finalDate, categoryId = "default",
                    description = "Copertura spesa", merchantKey = "Fondo di Emergenza", subcategoryText = "Intervento Scudo", logoEmoji = "🛡️", logoUri = null, isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = timeNowMs - 5, updatedAtEpochMs = timeNowMs - 5
                )
                viewModel.saveTransaction(drainTx)
            } else {
                val deadDrain = original.copy(id = "tx_drain_$mainTxId", isDeleted = true, updatedAtEpochMs = timeNowMs)
                viewModel.saveTransaction(deadDrain)
            }

            if (isIncome && isSavingsActive && selectedAccountId.isNotBlank()) {
                val pct = percentageText.toFloatOrNull() ?: 0f
                val amountToSave = (finalAmount.toFloat() * (pct / 100f)).toLong()
                if (amountToSave > 0L) {
                    val activePiggyBanks = db.piggyBankQueries.all().awaitAsList().filter { !it.isDeleted }
                    if (activePiggyBanks.isNotEmpty()) {
                        val targetBank = activePiggyBanks.first()
                        val savingsCat = categories.firstOrNull { it.name.contains("Risparmi", ignoreCase = true) }?.id ?: "cat_savings_auto"

                        val sweepTx = TransactionEntity(
                            id = "tx_save_$mainTxId", accountId = selectedAccountId, toAccountId = "", fromAccountId = "", amountCents = amountToSave, type = "EXPENSE", dateEpochDay = finalDate, categoryId = savingsCat,
                            description = "Accantonamento: ${pct.toInt()}%" + (if (pct == 100f) " (TUTTO)" else ""), merchantKey = "Salvadanaio: ${targetBank.name} [pb:${targetBank.id}][p:$mainTxId]", subcategoryText = "Risparmio Manuale", logoEmoji = targetBank.emoji.takeIf { it.isNotBlank() } ?: "🪙", logoUri = targetBank.imageUri ?: "", isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs + 100, updatedAtEpochMs = nowMs + 100
                        )
                        viewModel.saveTransaction(sweepTx)

                        val updatedBank = targetBank.copy(accumulatedCents = targetBank.accumulatedCents + amountToSave, updatedAtEpochMs = nowMs + 100)
                        db.piggyBankQueries.upsert(updatedBank.id, updatedBank.name, updatedBank.accumulatedCents, updatedBank.emoji, updatedBank.colorHex, updatedBank.imageUri, updatedBank.isDeleted, updatedBank.createdAtEpochMs, updatedBank.updatedAtEpochMs)
                        try { viewModel.firestore.salva("salvadanai", updatedBank.id, updatedBank) } catch(e: Exception) {}
                    }
                }
            } else {
                val deadSweep = original.copy(id = "tx_save_$mainTxId", isDeleted = true, updatedAtEpochMs = timeNowMs)
                viewModel.saveTransaction(deadSweep)
            }

            val feeCents = parseEuroToCentsSafe(feeText)
            if (feeCents > 0L && !isTransfer) {
                val feeTx = TransactionEntity(
                    id = "fee_$mainTxId", type = TYPE_EXPENSE, accountId = selectedAccountId, fromAccountId = "", toAccountId = "", amountCents = feeCents, dateEpochDay = finalDate, categoryId = finalCategoryId ?: "default",
                    description = "Commissione: ${normalizeTextSafe(merchant)}".trim(), merchantKey = "Commissioni ${normalizeTextSafe(merchant)}".trim(), logoEmoji = safeEmoji, logoUri = safeUri, subcategoryText = "Commissioni", isHidden = false, isDeleted = false, reminderDays = null, createdAtEpochMs = nowMs + 10, updatedAtEpochMs = nowMs + 10
                )
                viewModel.saveTransaction(feeTx)
            } else {
                val deadFee = original.copy(id = "fee_$mainTxId", isDeleted = true, updatedAtEpochMs = timeNowMs)
                viewModel.saveTransaction(deadFee)
            }

            val mainTx = TransactionEntity(
                id = mainTxId, type = original.type, accountId = if (isTransfer) "" else finalAccountId, fromAccountId = if (isTransfer) finalFromId else "", toAccountId = if (isTransfer) finalToId else "",
                amountCents = finalAmount, dateEpochDay = finalDate, categoryId = finalCategoryId ?: "default", description = finalDesc.replace(" \uD83D\uDC7B (Promemoria)", "").trim(), merchantKey = if (isTransfer) "Trasferimento" else normalizeTextSafe(merchant).replace(" \uD83D\uDC7B (Promemoria)", "").trim(),
                logoEmoji = safeEmoji, logoUri = safeUri, subcategoryText = if (isTransfer) "" else normalizeTextSafe(subcategory), isHidden = original.isHidden, isDeleted = original.isDeleted, reminderDays = original.reminderDays, createdAtEpochMs = original.createdAtEpochMs, updatedAtEpochMs = nowMs
            )
            viewModel.saveTransaction(mainTx)
            onSaved()
        }
    }

    val pickerThemeColor = remember(original.type) {
        when (original.type) {
            "INCOME" -> Color(0xFF059669)
            "TRANSFER" -> Color(0xFF0284C7)
            else -> Color(0xFFDC2626)
        }
    }

    val bgGradient = remember(original.type) {
        val colors = when (original.type) {
            "INCOME" -> listOf(
                Color(0xFF059669).copy(alpha = 0.75f),
                Color(0xFF064E3B),
                Color(0xFF0F172A)
            )
            "TRANSFER" -> listOf(
                Color(0xFF0284C7).copy(alpha = 0.75f),
                Color(0xFF0C4A6E),
                Color(0xFF0F172A)
            )
            else -> listOf( // EXPENSE
                Color(0xFFDC2626).copy(alpha = 0.75f),
                Color(0xFF7F1D1D),
                Color(0xFF0F172A)
            )
        }
        Brush.verticalGradient(colors = colors)
    }

    Dialog(
        onDismissRequest = onDismiss,
        properties = DialogProperties(
            usePlatformDefaultWidth = false,
            dismissOnClickOutside = true,
            dismissOnBackPress = true
        )
    ) {
        Surface(
            modifier = Modifier.fillMaxSize(),
            color = Color.Transparent
        ) {
            Box(modifier = Modifier.fillMaxSize().background(bgGradient).blur(dialogBlur)) {
                Column(modifier = Modifier.fillMaxSize().systemBarsPadding().imePadding()) {
                    if (isScanningReceipt) {
                        LinearProgressIndicator(modifier = Modifier.fillMaxWidth().height(4.dp), color = brandPrimary)
                    }

                    // HEADER
                    Row(
                        modifier = Modifier.fillMaxWidth().padding(16.dp),
                        verticalAlignment = Alignment.CenterVertically
                    ) {
                        IconButton(onClick = onDismiss) {
                            Icon(Icons.AutoMirrored.Filled.ArrowBack, contentDescription = "Indietro", tint = Color.White)
                        }
                    }
                    Text(
                        text = "Modifica Movimento",
                        style = MaterialTheme.typography.headlineMedium.copy(fontWeight = FontWeight.Bold),
                        color = Color.White,
                        modifier = Modifier.padding(horizontal = 24.dp)
                    )
                    Spacer(Modifier.height(24.dp))

                AnimatedVisibility(visible = receiptError) {
                    Text(
                        text = "Scontrino non riconosciuto o illeggibile. Riprova.",
                        color = MaterialTheme.colorScheme.error,
                        style = MaterialTheme.typography.labelMedium,
                        modifier = Modifier.padding(horizontal = 24.dp)
                    )
                }

                // CORPO SCORREVOLE CENTRALE
                Column(
                    modifier = Modifier
                        .fillMaxWidth()
                        .weight(1f)
                        .verticalScroll(rememberScrollState())
                        .padding(start = 24.dp, end = 24.dp, top = 8.dp, bottom = 120.dp),
                    verticalArrangement = Arrangement.spacedBy(16.dp)
                ) {

                    if (isFinancingInstallment) {
                        Surface(color = Color(0xFF1C1C1E), shape = RoundedCornerShape(14.dp), modifier = Modifier.fillMaxWidth()) {
                            Text("Nota: questa è una rata automatica. Alcuni campi sono bloccati.", style = MaterialTheme.typography.bodySmall, color = brandPrimary, modifier = Modifier.padding(12.dp))
                        }
                    }

                    // IMPORTO
                    Column {
                        StableWebNumberField(
                            value = amountText,
                            onValueChange = { amountText = it },
                            label = "IMPORTO (€)",
                            enabled = !isFinancingInstallment,
                            interactionSource = amountInteractionSource,
                            trailingIcon = {
                                IconButton(onClick = { if(!isFinancingInstallment) activeAmountTarget = EditTxAmountTarget.AMOUNT }) {
                                    Icon(Icons.Default.MoreVert, null, tint = Color.White)
                                }
                            }
                        )

                        Spacer(Modifier.height(8.dp))
                        Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.SpaceEvenly) {
                            OutlinedButton(
                                onClick = { isImageActionForOCR = true; receiptError = false; mediaHandler.launchCamera() },
                                modifier = Modifier.weight(1f).height(40.dp),
                                shape = RoundedCornerShape(8.dp),
                                colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                            ) {
                                Icon(Icons.Outlined.CameraAlt, contentDescription = null, modifier = Modifier.size(16.dp))
                                Spacer(Modifier.width(6.dp))
                                Text("Scatta OCR", style = MaterialTheme.typography.labelMedium)
                            }
                            Spacer(Modifier.width(8.dp))
                            OutlinedButton(
                                onClick = { isImageActionForOCR = true; receiptError = false; mediaHandler.launchGallery() },
                                modifier = Modifier.weight(1f).height(40.dp),
                                shape = RoundedCornerShape(8.dp),
                                colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White),
                                border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f))
                            ) {
                                Icon(Icons.Outlined.Search, contentDescription = null, modifier = Modifier.size(16.dp))
                                Spacer(Modifier.width(6.dp))
                                Text("Scontrino", style = MaterialTheme.typography.labelMedium)
                            }
                        }
                    }

                    // 🚀 SEZIONE RISPARMIO CON TAB RAPIDI E ANTEPRIMA IMPORTO LIVE
                    if (isIncome) {
                        Column(modifier = Modifier.fillMaxWidth().padding(vertical = 4.dp)) {
                            Row(
                                verticalAlignment = Alignment.CenterVertically,
                                modifier = Modifier.fillMaxWidth().clickable { isSavingsActive = !isSavingsActive }
                            ) {
                                MonetixGlassSwitch(checked = isSavingsActive, onCheckedChange = { isSavingsActive = it }, activeColor = Color(0xFF0284C7))
                                Spacer(Modifier.width(12.dp))
                                Text("Metti da parte nel salvadanaio", style = MaterialTheme.typography.bodyMedium, color = Color.White)
                            }
                            AnimatedVisibility(visible = isSavingsActive) {
                                Column(modifier = Modifier.fillMaxWidth().padding(top = 12.dp), verticalArrangement = Arrangement.spacedBy(12.dp)) {

                                    val totalCents = remember(amountText) { parseEuroToCentsSafe(amountText) }
                                    val currentPct = percentageText.toFloatOrNull() ?: 0f
                                    val previewCents = (totalCents * (currentPct / 100f)).toLong()
                                    val previewString = formatEuroFromCents(previewCents)

                                    Row(modifier = Modifier.fillMaxWidth(), horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                        listOf("10%", "25%", "50%", "100%").forEach { tabLabel ->
                                            val tabValue = tabLabel.replace("%", "")
                                            val isSelected = percentageText == tabValue
                                            FilterChip(
                                                selected = isSelected,
                                                onClick = { percentageText = tabValue },
                                                label = {
                                                    Text(
                                                        text = tabLabel,
                                                        fontWeight = FontWeight.Bold,
                                                        color = if (isSelected) MaterialTheme.colorScheme.onPrimary else MaterialTheme.colorScheme.onSurface
                                                    )
                                                },
                                                shape = RoundedCornerShape(16.dp),
                                                colors = FilterChipDefaults.filterChipColors(
                                                    selectedContainerColor = brandPrimary,
                                                    selectedLabelColor = MaterialTheme.colorScheme.onPrimary,
                                                    containerColor = MaterialTheme.colorScheme.surfaceVariant.copy(alpha = 0.4f),
                                                    labelColor = MaterialTheme.colorScheme.onSurfaceVariant
                                                ),
                                                border = null
                                            )
                                        }
                                    }
                                    OutlinedTextField(
                                        value = percentageText,
                                        onValueChange = { if (it.all { c -> c.isDigit() } && (it.toIntOrNull() ?: 0) <= 100) percentageText = it },
                                        label = { Text("Percentuale manuale (0-100)") },
                                        trailingIcon = { Text("%", fontWeight = FontWeight.ExtraBold, color = brandPrimary, modifier = Modifier.padding(end = 8.dp)) },
                                        supportingText = {
                                            if (previewCents > 0L) {
                                                Text(
                                                    text = "Metterai da parte: $previewString",
                                                    fontWeight = FontWeight.Bold,
                                                    color = Color(0xFF10B981)
                                                )
                                            }
                                        },
                                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                                        interactionSource = savingsInteractionSource, modifier = Modifier.fillMaxWidth(), shape = RoundedCornerShape(14.dp)
                                    )
                                }
                            }
                        }
                    }

                    OutlinedTextField(
                        value = dateTFV,
                        onValueChange = onDateTFVChange,
                        label = { Text("DATA (GG/MM/AAAA)", style = MaterialTheme.typography.labelSmall) },
                        enabled = !isFinancingInstallment,
                        interactionSource = dateInteractionSource,
                        keyboardOptions = KeyboardOptions(keyboardType = KeyboardType.Number),
                        modifier = Modifier.fillMaxWidth(),
                        shape = RoundedCornerShape(14.dp),
                        trailingIcon = {
                            IconButton(onClick = { if(!isFinancingInstallment) showDatePicker = true }) {
                                Icon(Icons.Default.CalendarMonth, null, tint = Color.White)
                            }
                        },
                        colors = OutlinedTextFieldDefaults.colors(
                            focusedTextColor = Color.White,
                            unfocusedTextColor = Color.White,
                            focusedContainerColor = Color.Black.copy(alpha = 0.35f),
                            unfocusedContainerColor = Color.Black.copy(alpha = 0.25f),
                            focusedBorderColor = Color.White.copy(alpha = 0.40f),
                            unfocusedBorderColor = Color.White.copy(alpha = 0.20f),
                            focusedLabelColor = Color.White,
                            unfocusedLabelColor = Color(0xFFA0A0A0)
                        )
                    )

                    if (!isTransfer && !isFinancingInstallment) {
                        StableWebNumberField(
                            value = feeText,
                            onValueChange = { feeText = it },
                            label = "AGGIUNGI COMMISSIONE (€)",
                            interactionSource = feeInteractionSource,
                            leadingIcon = { Icon(Icons.Default.AddCircleOutline, null, tint = Color.White.copy(alpha = 0.8f)) },
                            trailingIcon = {
                                IconButton(onClick = { activeAmountTarget = EditTxAmountTarget.FEE }) {
                                    Icon(Icons.Default.MoreVert, null, tint = Color.White)
                                }
                            }
                        )
                    }

                    // LOGO E EMOJI
                    if (!isTransfer) {
                        Column(verticalArrangement = Arrangement.spacedBy(12.dp)) {
                            Text("LOGO E ICONA", style = MaterialTheme.typography.labelSmall, color = Color.White)
                            Row(verticalAlignment = Alignment.CenterVertically, horizontalArrangement = Arrangement.spacedBy(16.dp)) {

                                com.example.monetix.ui.components.TxLogo(
                                    logoEmoji = if (isTransfer) accounts.find { it.id == selectedToAccountId }?.logoEmoji else logoEmoji.takeIf { it.isNotBlank() },
                                    logoUri = if (isTransfer) accounts.find { it.id == selectedToAccountId }?.logoUri else logoUri.takeIf { it?.isNotBlank() == true },
                                    name = if (isTransfer) "Trasferimento" else merchant.ifBlank { "M" },
                                    modifier = Modifier.size(54.dp).border(1.dp, Color.White.copy(alpha = 0.2f), CircleShape)
                                )

                                FlowRow(modifier = Modifier.weight(1f), horizontalArrangement = Arrangement.spacedBy(6.dp), verticalArrangement = Arrangement.spacedBy(6.dp)) {
                                    OutlinedButton(onClick = { isImageActionForOCR = false; mediaHandler.launchGallery() }, modifier = Modifier.height(36.dp), shape = RoundedCornerShape(8.dp), colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White), border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f)), contentPadding = PaddingValues(horizontal = 12.dp)) { Text("FOTO", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                                    OutlinedButton(onClick = { showEmojiInput = !showEmojiInput; showWebSearch = false }, modifier = Modifier.height(36.dp), shape = RoundedCornerShape(8.dp), colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White), border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f)), contentPadding = PaddingValues(horizontal = 12.dp)) { Text("EMOJI", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                                    OutlinedButton(onClick = { showWebSearch = true; showEmojiInput = false }, modifier = Modifier.height(36.dp), shape = RoundedCornerShape(8.dp), colors = ButtonDefaults.outlinedButtonColors(containerColor = Color.White.copy(alpha = 0.10f), contentColor = Color.White), border = BorderStroke(1.dp, Color.White.copy(alpha = 0.25f)), contentPadding = PaddingValues(horizontal = 12.dp)) { Text("WEB", style = MaterialTheme.typography.labelSmall, color = Color.White) }
                                }
                            }
                            AnimatedVisibility(visible = showEmojiInput) {
                                StableWebTextField(
                                    value = logoEmoji,
                                    onValueChange = { if (it.length <= 3) { logoEmoji = it; logoUri = ""; manualLogoSet = true } },
                                    label = "Inserisci Emoji"
                                )
                            }
                        }
                    }

                    // INTERRUTTORE PROMEMORIA / REALE
                    Surface(
                        modifier = Modifier.fillMaxWidth().padding(bottom = 12.dp, top = 8.dp),
                        shape = RoundedCornerShape(16.dp),
                        color = Color.White.copy(alpha = 0.08f),
                        border = BorderStroke(1.dp, Color.White.copy(alpha = 0.15f))
                    ) {
                        Row(modifier = Modifier.padding(12.dp), verticalAlignment = Alignment.CenterVertically) {
                            MonetixGlassSwitch(checked = isRealTransaction, onCheckedChange = { isRealTransaction = it }, activeColor = Color(0xFF0284C7))
                            Spacer(Modifier.width(12.dp))
                            Column {
                                Text("Movimenta il conto", style = MaterialTheme.typography.titleSmall, fontWeight = FontWeight.Bold, color = Color.White)
                                Text(
                                    text = if (isRealTransaction) "I soldi modificano il saldo reale" else "Solo promemoria (Es. Contanti)",
                                    style = MaterialTheme.typography.bodySmall,
                                    color = Color(0xFFA0A0A0)
                                )
                            }
                        }
                    }

                    // CONTI
                    AnimatedVisibility(visible = isRealTransaction) {
                        if (!isTransfer) {
                            var accExpanded by remember { mutableStateOf(false) }
                            ExposedDropdownMenuBox(expanded = accExpanded, onExpandedChange = { if(!isFinancingInstallment) accExpanded = !accExpanded }) {
                                val current = accounts.firstOrNull { it.id == selectedAccountId }
                                OutlinedTextField(
                                    value = current?.name?.let { stripSystemMarker(it) ?: it } ?: "",
                                    onValueChange = {}, readOnly = true, label = { Text("CONTO", style = MaterialTheme.typography.labelSmall) },
                                    enabled = !isFinancingInstallment, trailingIcon = { Icon(Icons.Default.KeyboardArrowDown, null, tint = Color.White) },
                                    modifier = Modifier.menuAnchor().fillMaxWidth(), shape = RoundedCornerShape(14.dp),
                                    colors = OutlinedTextFieldDefaults.colors(
                                        focusedTextColor = Color.White,
                                        unfocusedTextColor = Color.White,
                                        focusedContainerColor = Color.White.copy(alpha = 0.10f),
                                        unfocusedContainerColor = Color.White.copy(alpha = 0.05f),
                                        focusedBorderColor = Color.White.copy(alpha = 0.35f),
                                        unfocusedBorderColor = Color.White.copy(alpha = 0.15f),
                                        focusedLabelColor = Color.White,
                                        unfocusedLabelColor = Color(0xFFA0A0A0)
                                    )
                                )
                                DropdownMenu(expanded = accExpanded, onDismissRequest = { accExpanded = false }, modifier = Modifier.exposedDropdownSize(), containerColor = Color(0xFF1C1C1E)) {
                                    accounts.filter { !it.isArchived && !it.isDeleted }.forEach { a -> DropdownMenuItem(text = { Text(stripSystemMarker(a.name) ?: a.name, color = Color.White) }, onClick = { selectedAccountId = a.id; accExpanded = false }) }
                                }
                            }
                        } else {
                            var fromExp by remember { mutableStateOf(false) }
                            ExposedDropdownMenuBox(expanded = fromExp, onExpandedChange = { fromExp = !fromExp }) {
                                val cur = accounts.firstOrNull { it.id == selectedFromAccountId }
                                OutlinedTextField(
                                    value = cur?.name?.let { stripSystemMarker(it) ?: it } ?: "", onValueChange = {}, readOnly = true, label = { Text("DA CONTO", style = MaterialTheme.typography.labelSmall) },
                                    modifier = Modifier.menuAnchor().fillMaxWidth(), shape = RoundedCornerShape(14.dp),
                                    colors = OutlinedTextFieldDefaults.colors(
                                        focusedTextColor = Color.White,
                                        unfocusedTextColor = Color.White,
                                        focusedContainerColor = Color.White.copy(alpha = 0.10f),
                                        unfocusedContainerColor = Color.White.copy(alpha = 0.05f),
                                        focusedBorderColor = Color.White.copy(alpha = 0.35f),
                                        unfocusedBorderColor = Color.White.copy(alpha = 0.15f),
                                        focusedLabelColor = Color.White,
                                        unfocusedLabelColor = Color(0xFFA0A0A0)
                                    )
                                )
                                DropdownMenu(expanded = fromExp, onDismissRequest = { fromExp = false }, modifier = Modifier.exposedDropdownSize(), containerColor = Color(0xFF1C1C1E)) {
                                    accounts.filter { !it.isArchived && !it.isDeleted }.forEach { a -> DropdownMenuItem(text = { Text(stripSystemMarker(a.name) ?: a.name, color = Color.White) }, onClick = { selectedFromAccountId = a.id; fromExp = false }) }
                                }
                            }

                            var toExp by remember { mutableStateOf(false) }
                            ExposedDropdownMenuBox(expanded = toExp, onExpandedChange = { toExp = !toExp }) {
                                val cur = accounts.firstOrNull { it.id == selectedToAccountId }
                                OutlinedTextField(
                                    value = cur?.name?.let { stripSystemMarker(it) ?: it } ?: "", onValueChange = {}, readOnly = true, label = { Text("A CONTO", style = MaterialTheme.typography.labelSmall) },
                                    modifier = Modifier.menuAnchor().fillMaxWidth(), shape = RoundedCornerShape(14.dp),
                                    colors = OutlinedTextFieldDefaults.colors(
                                        focusedTextColor = Color.White,
                                        unfocusedTextColor = Color.White,
                                        focusedContainerColor = Color.White.copy(alpha = 0.10f),
                                        unfocusedContainerColor = Color.White.copy(alpha = 0.05f),
                                        focusedBorderColor = Color.White.copy(alpha = 0.35f),
                                        unfocusedBorderColor = Color.White.copy(alpha = 0.15f),
                                        focusedLabelColor = Color.White,
                                        unfocusedLabelColor = Color(0xFFA0A0A0)
                                    )
                                )
                                DropdownMenu(expanded = toExp, onDismissRequest = { toExp = false }, modifier = Modifier.exposedDropdownSize(), containerColor = Color(0xFF1C1C1E)) {
                                    accounts.filter { !it.isArchived && !it.isDeleted && it.id != selectedFromAccountId }.forEach { a -> DropdownMenuItem(text = { Text(stripSystemMarker(a.name) ?: a.name, color = Color.White) }, onClick = { selectedToAccountId = a.id; toExp = false }) }
                                }
                            }
                        }
                    }

                    if (!isTransfer) {
                        Column(modifier = Modifier.fillMaxWidth()) {
                            Box(modifier = Modifier.fillMaxWidth()) {
                                StableWebTextField(
                                    value = merchant,
                                    onValueChange = {
                                        merchant = it
                                        merchantSuggestionsExpanded = it.isNotBlank()
                                    },
                                    label = "ESERCENTE",
                                    interactionSource = merchantInteractionSource
                                )

                                val filteredMerchants = dynamicMerchantSuggestions.filter {
                                    it.name.contains(merchant, ignoreCase = true)
                                }

                                DropdownMenu(
                                    expanded = merchantSuggestionsExpanded && filteredMerchants.isNotEmpty() && isMerchantFocused,
                                    onDismissRequest = { merchantSuggestionsExpanded = false },
                                    properties = PopupProperties(focusable = false),
                                    modifier = Modifier.fillMaxWidth(0.8f).heightIn(max = 220.dp).background(Color(0xFF1C1C1E))
                                ) {
                                    filteredMerchants.take(10).forEach { merch ->
                                        DropdownMenuItem(
                                            text = { Text(merch.name.cleanDisplayName(), fontWeight = FontWeight.SemiBold, color = Color.White) },
                                            leadingIcon = {
                                                TxLogo(
                                                    logoEmoji = merch.emoji,
                                                    logoUri = merch.url,
                                                    name = merch.name.cleanDisplayName(),
                                                    modifier = Modifier.size(24.dp)
                                                )
                                            },
                                            onClick = {
                                                merchant = merch.name
                                                if (categoryText.isBlank()) categoryText = merch.suggestedCategory
                                                if (subcategory.isBlank()) subcategory = merch.suggestedSubcategory

                                                logoUri = merch.url ?: ""
                                                logoEmoji = merch.emoji ?: ""
                                                manualLogoSet = true

                                                merchantSuggestionsExpanded = false
                                            }
                                        )
                                    }
                                }
                            }

                            AnimatedVisibility(visible = merchant.isBlank()) {
                                Column(modifier = Modifier.padding(top = 12.dp)) {
                                    Text("Suggeriti:", style = MaterialTheme.typography.labelSmall, color = Color(0xFFA0A0A0))
                                    Spacer(Modifier.height(8.dp))
                                    LazyRow(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                                        items(dynamicMerchantSuggestions.filter { it.name.cleanDisplayName().isNotBlank() }.take(8)) { merch ->
                                            FilterChip(
                                                selected = false,
                                                onClick = {
                                                    merchant = merch.name.cleanDisplayName()
                                                    if (categoryText.isBlank()) categoryText = merch.suggestedCategory
                                                    if (subcategory.isBlank()) subcategory = merch.suggestedSubcategory

                                                    logoUri = merch.url ?: ""
                                                    logoEmoji = merch.emoji ?: ""
                                                    manualLogoSet = true
                                                },
                                                label = { Text(merch.name.cleanDisplayName(), style = MaterialTheme.typography.bodySmall, color = Color.White) },
                                                leadingIcon = {
                                                    when {
                                                        merch.url != null -> AsyncImage(model = merch.url, contentDescription = null, modifier = Modifier.size(16.dp))
                                                        merch.emoji != null -> Text(merch.emoji, fontSize = 14.sp)
                                                    }
                                                },
                                                shape = RoundedCornerShape(16.dp)
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }

                    Box(modifier = Modifier.fillMaxWidth()) {
                        StableWebTextField(
                            value = categoryText,
                            onValueChange = { categoryText = it; categoryMenuOpen = true },
                            label = "CATEGORIA",
                            interactionSource = catInteractionSource,
                            trailingIcon = { IconButton(onClick = { categoryMenuOpen = !categoryMenuOpen }) { Icon(if (categoryMenuOpen) Icons.Default.KeyboardArrowUp else Icons.Default.KeyboardArrowDown, null) } }
                        )

                        DropdownMenu(
                            expanded = categoryMenuOpen && isCatFocused,
                            onDismissRequest = { categoryMenuOpen = false },
                            containerColor = Color(0xFF1C1C1E),
                            modifier = Modifier.fillMaxWidth(0.8f).heightIn(max = 220.dp),
                            properties = PopupProperties(focusable = false)
                        ) {
                            DropdownMenuItem(
                                text = { Text("Nessuna categoria", color = Color.White) },
                                colors = MenuDefaults.itemColors(textColor = Color.White),
                                onClick = { categoryText = ""; selectedCategoryId = ""; categoryMenuOpen = false }
                            )
                            val filtered = localCategories.filter { !it.isDeleted && it.name.contains(categoryText, ignoreCase = true) }
                            if (categoryText.isNotBlank() && filtered.none { it.name.equals(categoryText, ignoreCase = true) }) {
                                DropdownMenuItem(
                                    text = { Text("+ Crea \"${categoryText.uppercase()}\"", color = Color(0xFF60A5FA), fontWeight = FontWeight.Bold) },
                                    colors = MenuDefaults.itemColors(textColor = Color(0xFF60A5FA)),
                                    onClick = {
                                        val catTextClean = categoryText.trim().uppercase()
                                        val norm = catTextClean.lowercase().replace("\\s+".toRegex(), "_").replace("[^a-z0-9_]+".toRegex(), "")
                                        val newId = "cat_$norm"
                                        val newCat = CategoryEntity(newId, catTextClean, false, nowMs, nowMs)
                                        scope.launch {
                                            db.categoryQueries.upsert(newId, catTextClean, false, nowMs, nowMs)
                                            try { viewModel.firestore.salva("categorie", newId, newCat) } catch(e: Exception){}
                                        }
                                        categoryText = catTextClean; selectedCategoryId = newId; categoryMenuOpen = false
                                    }
                                )
                            }
                            filtered.forEach { cat ->
                                DropdownMenuItem(
                                    text = { Text(cat.name, color = Color.White) },
                                    colors = MenuDefaults.itemColors(textColor = Color.White),
                                    trailingIcon = { IconButton(onClick = { pendingDeleteCat = cat; categoryMenuOpen = false }) { Icon(Icons.Outlined.Delete, "Elimina", tint = MaterialTheme.colorScheme.error.copy(alpha=0.6f)) } },
                                    onClick = { categoryText = cat.name; selectedCategoryId = cat.id; categoryMenuOpen = false }
                                )
                            }
                        }
                    }

                    if (!isTransfer) {
                        StableWebTextField(
                            value = subcategory,
                            onValueChange = { subcategory = it },
                            label = "SOTTO-CATEGORIA"
                        )
                        StableWebTextField(
                            value = desc,
                            onValueChange = { desc = it },
                            label = "NOTE", enabled = !isFinancingInstallment
                        )
                    } else {
                        StableWebTextField(
                            value = desc,
                            onValueChange = { desc = it },
                            label = "NOTE TRASFERIMENTO"
                        )
                    }
                } // Fine del corpo scorrevole
            } // Fine Column contenitore
            
            val haptic = LocalHapticFeedback.current
            if (canSave) {
                FloatingActionButton(
                    onClick = {
                        val finalAmount = parseEuroToCentsSafe(amountText)
                        val saldoEffettivo = saldoDisponibile + if (original.type == TYPE_EXPENSE) original.amountCents else 0L

                        if (original.type == TYPE_EXPENSE && finalAmount > saldoEffettivo) {
                            val deficit = finalAmount - saldoEffettivo
                            if (emergencyBalanceCents >= deficit) {
                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                pendingEmergencyDeficit = deficit
                                showSmartEmergencyWarning = true
                                return@FloatingActionButton
                            } else {
                                haptic.performHapticFeedback(HapticFeedbackType.LongPress)
                                showSaldoWarning = true
                                return@FloatingActionButton
                            }
                        }

                        performSaveTransaction(false, 0L)
                    },
                    containerColor = if (canSave) pickerThemeColor else Color.White.copy(alpha = 0.12f),
                    modifier = Modifier
                        .align(Alignment.BottomEnd)
                        .navigationBarsPadding()
                        .padding(end = 24.dp, bottom = 64.dp)
                ) {
                    Icon(Icons.Default.ArrowDownward, contentDescription = "Salva", tint = if (canSave) Color.White else Color(0xFFA0A0A0))
                }
            }
        }
        } // Chiude il Surface e pure il Box

        if (activeAmountTarget != EditTxAmountTarget.NONE) {
            val initialText = if (activeAmountTarget == EditTxAmountTarget.AMOUNT) amountText else feeText
            val parsedInitial = initialText.replace(',', '.').toDoubleOrNull() ?: 0.0
            var tempEuro by remember { mutableStateOf(kotlin.math.floor(parsedInitial).toInt().coerceIn(0, 5000)) }
            var tempCent by remember { mutableStateOf(((parsedInitial - kotlin.math.floor(parsedInitial)) * 100).roundToInt().coerceIn(0, 99)) }

            AlertDialog(
                onDismissRequest = { activeAmountTarget = EditTxAmountTarget.NONE },
                containerColor = Color.White.copy(alpha = 0.12f),
                shape = RoundedCornerShape(28.dp),
                title = { Text(if (activeAmountTarget == EditTxAmountTarget.AMOUNT) "Importo Operazione" else "Commissioni", fontWeight = FontWeight.Bold, color = Color.White) },
                text = {
                    Column(modifier = Modifier.fillMaxWidth().padding(top = 8.dp)) {
                        Text(text = "${tempEuro},${tempCent.toString().padStart(2, '0')} €", style = MaterialTheme.typography.headlineMedium.copy(fontWeight = FontWeight.ExtraBold), color = Color.White, modifier = Modifier.align(Alignment.CenterHorizontally))
                        Spacer(Modifier.height(24.dp))
                        Row(modifier = Modifier.fillMaxWidth().height(160.dp), horizontalArrangement = Arrangement.Center, verticalAlignment = Alignment.CenterVertically) {
                            WheelPicker(items = (0..5000).toList(), initialValue = tempEuro, onValueChanged = { tempEuro = it }, modifier = Modifier.weight(1f))
                            Text(",", style = MaterialTheme.typography.headlineLarge, color = Color.White, modifier = Modifier.padding(horizontal = 16.dp))
                            WheelPicker(items = (0..99).toList(), initialValue = tempCent, onValueChanged = { tempCent = it }, modifier = Modifier.weight(1f), labelExtractor = { it.toString().padStart(2, '0') })
                        }
                    }
                },
                confirmButton = {
                    TextButton(onClick = {
                        val newVal = "${tempEuro},${tempCent.toString().padStart(2, '0')}"
                        if (activeAmountTarget == EditTxAmountTarget.AMOUNT) amountText = newVal else feeText = newVal
                        activeAmountTarget = EditTxAmountTarget.NONE
                    }) { Text("CONFERMA", color = pickerThemeColor, fontWeight = FontWeight.Bold) }
                },
                dismissButton = {
                    TextButton(onClick = { activeAmountTarget = EditTxAmountTarget.NONE }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
                }
            )
        }

        if (showDatePicker) {
            DatePickerDialog(
                onDismissRequest = { showDatePicker = false },
                confirmButton = {
                    TextButton(onClick = {
                        datePickerState.selectedDateMillis?.let { millis ->
                            val selectedDate = Instant.fromEpochMilliseconds(millis).toLocalDateTime(TimeZone.currentSystemDefault()).date
                            val s = "${selectedDate.dayOfMonth.toString().padStart(2, '0')}/${selectedDate.monthNumber.toString().padStart(2, '0')}/${selectedDate.year}"
                            dateTFV = TextFieldValue(s, TextRange(s.length))
                        }
                        showDatePicker = false
                    }) { Text("OK", fontWeight = FontWeight.Bold, color = pickerThemeColor) }
                },
                dismissButton = {
                    TextButton(onClick = { showDatePicker = false }) { Text("ANNULLA", color = Color.White, fontWeight = FontWeight.Bold) }
                },
                colors = DatePickerDefaults.colors(containerColor = Color(0xFF1E1B4B))
            ) {
                DatePicker(
                    state = datePickerState,
                    colors = DatePickerDefaults.colors(
                        containerColor = Color(0xFF1E1B4B),
                        titleContentColor = Color.White,
                        headlineContentColor = Color.White,
                        weekdayContentColor = Color(0xFFA0A0A0),
                        subheadContentColor = Color.White,
                        yearContentColor = Color.White,
                        currentYearContentColor = pickerThemeColor,
                        selectedYearContentColor = Color.White,
                        selectedYearContainerColor = pickerThemeColor,
                        dayContentColor = Color.White,
                        selectedDayContentColor = Color.White,
                        selectedDayContainerColor = pickerThemeColor,
                        todayContentColor = pickerThemeColor,
                        todayDateBorderColor = pickerThemeColor
                    )
                )
            }
        }

        if (showWebSearch) {
            WebImagePickerPopup(
                initialQuery = merchant,
                onDismiss = { showWebSearch = false },
                onImageSelected = { url ->
                    logoUri = url
                    logoEmoji = ""
                    manualLogoSet = true
                    showWebSearch = false
                }
            )
        }

// 🚀 POPUP DI AVVISO MODIFICA MANCANZA FONDI
        if (showSaldoWarning) {
            AlertDialog(
                onDismissRequest = { showSaldoWarning = false },
                title = { Text("Saldo Insufficiente ⚠️", fontWeight = FontWeight.Bold, color = MaterialTheme.colorScheme.error) },
                text = { Text("Stai cercando di modificare la spesa a ${formatEuroFromCents(parseEuroToCentsSafe(amountText))}, ma considerando la somma che avevi già pagato, il tuo saldo disponibile di ${formatEuroFromCents(saldoDisponibile)} non è sufficiente.") },
                confirmButton = { TextButton(onClick = { showSaldoWarning = false }) { Text("HO CAPITO") } }
            )
        }

        // 🚀 POPUP SMART SCUDO (FONDO EMERGENZA)
        if (showSmartEmergencyWarning) {
            val finalAmount = parseEuroToCentsSafe(amountText)
            AlertDialog(
                onDismissRequest = { showSmartEmergencyWarning = false },
                shape = RoundedCornerShape(24.dp),
                containerColor = MaterialTheme.colorScheme.surface,
                title = { Text("Fondo di Emergenza Necessario 🛡️", fontWeight = FontWeight.Bold, color = Color(0xFF3B82F6)) },
                text = {
                    Text(
                        text = "Il tuo saldo disponibile è di ${formatEuroFromCents(saldoDisponibile)}. Aumentando questa spesa a ${formatEuroFromCents(finalAmount)} preleveremo automaticamente i mancanti ${formatEuroFromCents(pendingEmergencyDeficit)} dal tuo Scudo.\n\nVuoi procedere?",
                        style = MaterialTheme.typography.bodyMedium
                    )
                },
                confirmButton = {
                    TextButton(onClick = {
                        showSmartEmergencyWarning = false
                        performSaveTransaction(true, pendingEmergencyDeficit)
                    }) { Text("PROCEDI", color = Color(0xFF3B82F6), fontWeight = FontWeight.Bold) }
                },
                dismissButton = { TextButton(onClick = { showSmartEmergencyWarning = false }) { Text("ANNULLA", color = MaterialTheme.colorScheme.onSurfaceVariant) } }
            )
        }
        // --- DIALOG ESTERNI ---
        pendingDeleteCat?.let { cat ->
            AlertDialog(
                onDismissRequest = { pendingDeleteCat = null },
                title = { Text("Elimina Categoria", style = MaterialTheme.typography.titleMedium) },
                text = { Text("Vuoi eliminare '${cat.name}'?") },
                confirmButton = {
                    TextButton(onClick = {
                        scope.launch {
                            db.categoryQueries.upsert(cat.id, cat.name, true, cat.createdAtEpochMs, Clock.System.now().toEpochMilliseconds())
                            try {
                                val deletedCat = cat.copy(isDeleted = true, updatedAtEpochMs = Clock.System.now().toEpochMilliseconds())
                                viewModel.firestore.salva("categorie", cat.id, deletedCat)
                            } catch(e: Exception){}
                            pendingDeleteCat = null
                            localCategories = localCategories.filter { it.id != cat.id }
                        }
                    }) { Text("ELIMINA", color = MaterialTheme.colorScheme.error) }
                },
                dismissButton = { TextButton(onClick = { pendingDeleteCat = null }) { Text("ANNULLA") } }
            )
        }
    }
}

// ==========================================
// 🚀 FUNZIONI DI UTILITÀ ISOLATE
// ==========================================

fun normalizeEuroInputSafe(input: String): String {
    var clean = input.replace(",", ".").filter { it.isDigit() || it == '.' }
    val dotIdx = clean.indexOf('.')
    if (dotIdx != -1) {
        val afterDot = clean.substring(dotIdx + 1).replace(".", "")
        clean = clean.substring(0, dotIdx + 1) + afterDot
        if (clean.length - dotIdx > 3) clean = clean.substring(0, dotIdx + 3)
    }
    return clean
}

fun normalizeTextSafe(input: String?): String {
    return input?.trim() ?: ""
}

fun parseEuroToCentsSafe(amountText: String): Long {
    val clean = amountText.replace(",", ".").trim()
    if (clean.isEmpty()) return 0L
    return try {
        val parts = clean.split(".")
        val euros = parts[0].toLongOrNull() ?: 0L
        val centsStr = if (parts.size > 1) parts[1].padEnd(2, '0').substring(0, 2) else "00"
        val cents = centsStr.toLongOrNull() ?: 0L
        euros * 100 + cents
    } catch (e: Exception) {
        0L
    }
}

fun parseDayMonthYearSafe(dateText: String): Long? {
    try {
        val parts = dateText.split("/")
        if (parts.size == 3) {
            val day = parts[0].toInt()
            val month = parts[1].toInt()
            val year = parts[2].toInt()
            return kotlinx.datetime.LocalDate(year, month, day).toEpochDays().toLong()
        }
    } catch (e: Exception) {}
    return null
}